export const SET_PLAYER_SETTINGS = 'SET_PLAYER_SETTINGS';
export const setPlayerSettings = value => ({
  type: SET_PLAYER_SETTINGS,
  value,
});

export const CLEAR_PLAYER_SETTINGS = 'CLEAR_PLAYER_SETTINGS';
export const clearPlayerSettings = () => ({
  type: CLEAR_PLAYER_SETTINGS,
});

export const SET_CHAPTER_LIST = 'SET_CHAPTER_LIST';
export const setChapterList = value => ({
  type: SET_CHAPTER_LIST,
  value,
});
